import { DragOutlined, EyeOutlined } from '@ant-design/icons';
import { Slider, Checkbox as AntCheckbox } from 'antd';
import styled from 'styled-components';

export const EyeIcon = styled(EyeOutlined)<{
  $disabled: boolean;
  $active: boolean;
}>`
  color: ${p => (p.$active ? p.theme.primary : 'unset')};
  font-size: 15px;
  margin: auto 0;
  opacity: ${p => (p.$disabled ? 0.3 : 0.6)};
  cursor: ${p =>
    p.$disabled ? 'not-allowed !important' : 'pointer !important'};
`;

export const OpacitySlider = styled(Slider)`
  flex: 1;
  margin-left: 10px;
`;

export const DragICon = styled(DragOutlined)`
  padding-right: 10px;
  margin: auto 0;
`;

export const Checkbox = styled(AntCheckbox)`
  display: block;
  margin-left: 0;
  flex: 1;
`;
